
import type { Identifiable } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'
import MutableList from '../mutable-list.component.vue'

type Item = unknown & Identifiable

export default defineComponent({
  name: 'ToolingSettingsList',
  components: {
    MutableList,
  },
  props: {
    items: {
      type: Array as PropType<Array<Item>>,
      required: true,
    },
    isSortable: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    remove: (item: Item) => {},
    move: (item: Item, targetIndex: number) => {},
  },
  setup(props, { emit }) {
    const baseClass = 'tooling-settings-list'

    const areManyItems = computed(() => props.items.length > 1)

    const onRemove = (item: Item): void => {
      emit('remove', item)
    }

    const onMoveItem = ({ targetIndex, item }): void => {
      emit('move', item, targetIndex)
    }

    return {
      areManyItems,
      baseClass,
      onMoveItem,
      onRemove,
    }
  },
})
